const {
  ADROLL_ADV_ID: AdrollAdvId,
  ADROLL_PIX_ID: AdrollPixId,
  STRIPE_PUBLIC_KEY: StripePublicKey,
  PLAID_PUBLIC_KEY: PlaidPublicKey,
  PLAID_ENV: PlaidEnv,
  RAVEN_URL: RavenUrl,
  TRACKING_PAGE_BASE: TrackingPageBase,
} = process.env;

const EasyPostConstants = {
  AdrollAdvId,
  AdrollPixId,
  StripePublicKey,
  PlaidPublicKey,
  PlaidEnv,
  RavenUrl,
  TrackingPageBase,
};

global.EasyPostConstants = EasyPostConstants;

export default EasyPostConstants;



// WEBPACK FOOTER //
// ./app/easypost_constants.js